import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore }                   from '@/stores/userstore';
import ResetPasswordConfirm               from '@/apps/ForgotPassword/views/ResetPasswordConfirm.vue';
import Inventory                          from '@/apps/Inventory/views/Inventory.vue';
import ManageUsers                        from '@/apps/ManageUsers/views/ManageUsers.vue';
import Sub_InventoryItemDetail            from '@/apps/Inventory/views/Sub_InventoryItemDetail.vue';
import Lobby                              from '@/apps/LobbyOS/views/Lobby.vue';
import AddMessage                         from '@/apps/LobbyOS/views/AddMessage.vue';
import AddPlaylist                        from '@/apps/LobbyOS/views/AddPlaylist.vue';
import PrestaEligibility                  from '@/apps/PrestaEligibility/views/PrestaEligibility.vue';
import EmailBlacklist                     from '@/apps/EmailBlacklist/vues/EmailBlacklist.vue';
import RappelSMS                          from '@/apps/RappelSMS/views/RappelSMS.vue';
import ConfirmationRDV                    from '@/apps/RappelSMS/views/ConfirmationRDV.vue';

const routes = [
  { path: '/', component: () => import('@/apps/Home/views/Home.vue') },
  { path: '/403', component: () => import('@/apps/Home/views/403.vue') },
  { path: '/Login', component: () => import('@/apps/Home/views/Login.vue') },
  { path: '/reset/:uidb64/:token', component: () => import('@/apps/ForgotPassword/views/ResetPasswordConfirm.vue')},
  { path: '/Gestion', component: () => import('@/apps/GestionRoles/views/Gestion.vue'), meta: { requiresAuth: true, requiredGroup: 'ADMIN_PANEL' }},
  { path: '/gerer_utilisateurs', name: 'manage_users', component: ManageUsers , meta: { requiresAuth: true, requiredGroup: 'ADMIN_PANEL' }},
  
  { path: '/Messagerie_home', component: () => import('@/apps/Messagerie/views/Messagerie_home.vue'), meta: { requiresAuth: true, requiredGroup: 'MSG_CONSEILLER' } },
  
  { path: '/EMG', component: () => import('@/apps/EMG/views/EMG.vue'), meta: { requiresAuth: true } },
  { path: '/EL', component: () => import('@/apps/EL/views/EL.vue'), meta: { requiresAuth: true } },
  
  { path: '/Satisfaction', component: () => import('@/apps/Satisfaction/views/Satisfaction.vue'), meta: { requiresAuth: true } },
  { path: '/Satisfaction/MesSondages', component: () => import('@/apps/Satisfaction/views/TabSondageSend.vue'), meta: { requiresAuth: true } },
  
  
  { path: '/Evaluation', component: () => import('@/apps/Evaluation/views/Evaluation.vue'), meta: { requiresAuth: true } },
  
  { path: '/Matrices', component: () => import('@/apps/Matrices/views/Matrices.vue'), meta: { requiresAuth: true } },
  { path: '/Matrices/Upload', component: () => import('@/apps/Matrices/views/Upload.vue'), meta: { requiresAuth: true } },
  
  { path: '/Prescrire', component: () => import('@/apps/Prescrire/views/Prescrire.vue'), meta: { requiresAuth: true } },
  { path: '/Prescrire_envoyer/:id', name:'Prescrire_envoyer', component: () => import('@/apps/Prescrire/views/Prescrire_envoyer.vue'), meta: { requiresAuth: true } },
  { path: '/Prescrire_Logs/', name:'Prescrire_logs', component: () => import('@/apps/Prescrire/views/LogsPrescrire.vue'), meta: { requiresAuth: true } },
  
  { path: '/Passeport/', name:'Passeport', component: () => import('@/apps/Passeport/views/Passeport.vue'), props: false, meta: { requiresAuth: true } },
  { path: '/Passeport/:id', name:'PasseportDetail', component: () => import('@/apps/Passeport/views/Passeport.vue'), props: true, meta: { requiresAuth: true } },
  { path: '/Passeport/New_porteur', component: () => import('@/apps/Passeport/views/New_Porteur.vue'), meta: { requiresAuth: true } },
  { path: '/Passeport/Print/:id', component: () => import('@/apps/Passeport/views/Print.vue'), meta: { requiresAuth: true } },
  
  { path: '/ComopsAdmin', component: () => import('@/apps/Comops/views/AdminPanel.vue'), meta: { requiresAuth: true, requiredGroup: 'ADMIN_COMOPS', secureToken: import.meta.env.VITE_COMOPS_ACCESS_TOKEN } },
  { path: '/ComopsAdmin/edit', component: () => import('@/apps/Comops/views/Sub_AdminPanelEdit.vue'), meta: { requiresAuth: true, requiredGroup: 'ADMIN_COMOPS' } },
  { path: '/access/:token', component: () => import('@/apps/Comops/views/PrestatairePanel.vue') },
  { path: "/comops/:id/ppt",name: "ComopsPPT",component: () => import("@/apps/Comops/views/ComopsPPT.vue"), meta: { requiresAuth: true, secureToken: import.meta.env.VITE_COMOPS_ACCESS_TOKEN }},
  
  { path: '/inventaire', name: "Inventory", component: Inventory, meta: { requiresAuth: true, requiredGroup: 'ADMIN_PANEL' } },
  { path: '/inventaire/detail/:url_token', name: "InventoryItemDetail", component: Sub_InventoryItemDetail, meta: { requiresAuth: true, requiredGroup: 'ADMIN_PANEL' } },
  
  { path: '/screens/:screen', name: "Lobby", component: Lobby },
  { path: '/lobby/add_message', name: "add_message", component: AddMessage, meta: { requiresAuth: true, requiredGroup: 'LOBBY_ADMIN' } },
  { path: '/lobby/add_playlist', name: "add_playlist", component: AddPlaylist, meta: { requiresAuth: true, requiredGroup: 'LOBBY_ADMIN' } },

  { path: '/presta-eligibility', name: 'PrestaEligibility', component: PrestaEligibility, meta: { requiresAuth: true, requiredGroup: 'PRESCRIPTION' } },  
  
  {
    path: '/Passeport/Public/:encoded',
    name: 'PasseportPublic',
    component: () => import('@/apps/Passeport/views/Passeport.vue'),
    props: route => {
      const decoded = atob(route.params.encoded); // base64 decode
      const [id_porteur, id_passeport] = decoded.split(':');
      return { id_porteur, id_passeport, safe_mode: true };
    },
    meta: { requiresAuth: false }
  },
  
  { path: '/EMG', component: () => import('@/apps/EMG/views/mail_emg.vue'), meta: { requiresAuth: true } },
  { path: '/sondage_incub', component: () => import('@/apps/Sondage_Incub/views/Sondage_Incub.vue'), meta: { requiresAuth: true, requiredGroup: 'SONDAGE_INCUBATEST' } },
  { path: '/gestion_sondages', component: () => import('@/apps/Sondage_Incub/views/Gestion.vue'), meta: { requiresAuth: true, requiredGroup: 'SONDAGE_INCUBATEST' } },
  { path: '/questionnaire/:token', component: () => import('@/apps/Sondage_Incub/views/Questionnaire.vue'), props: true },

  { path: '/email-blacklist', name: "EmailBlacklist", component: EmailBlacklist, meta: { requiresAuth: true, requiredGroup: 'MODERATOR' } },
  { path: '/Signature', name: "Signature", component: () => import('@/apps/Signature/views/Signature.vue'), meta: { requiresAuth: true } },
  { path: '/rappel_SMS', name: "RappelSMS", component: RappelSMS, meta: { requiresAuth: true, requiredGroup: 'SECRETARY' } },
  { path: '/confirm', name: "ConfirmationRDV", component: ConfirmationRDV, props: route => ({ ref: route.query.ref }) },
  
  { path: '/:pathMatch(.*)*', component: () => import('@/apps/Home/views/404.vue') } // Page 404, faut la laisser en dérnier dans la liste des routes
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const requiresAuth  = to.meta?.requiresAuth
  const requiredGroup = to.meta?.requiredGroup
  const secureToken   = to.meta?.secureToken
  const urlToken      = to.query.token
  const user          = useUserStore()

  // Autoriser si le token est valide
  if (secureToken && urlToken === secureToken) return next()

  // Autoriser l'accès si aucune authentification n'est requise
  if (!requiresAuth) return next()
  
  // Rediriger si l'utilisateur n'est pas authentifié
  if (!user.isLoggedIn) return next({ path: '/Login', query: { redirect: to.fullPath } })

  // Autoriser si l'utilisateur est authentifié et possède le rôle requis
  if (user.isLoggedIn && (!requiredGroup || user.current_user_groups?.includes(requiredGroup))) return next()

  // Rediriger les utilisateurs non autorisés
  return next({ path: '/403' })
})

export default router
